module.exports = __webpack_public_path__ + "img/avatar2.388cc1fd.png";